import { render, staticRenderFns } from "./Formazione.vue?vue&type=template&id=0295f249&scoped=true&"
import script from "./Formazione.vue?vue&type=script&lang=js&"
export * from "./Formazione.vue?vue&type=script&lang=js&"
import style0 from "./Formazione.vue?vue&type=style&index=0&id=0295f249&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0295f249",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
